import {
  INCREMENT_REFRESH,
  SET_PAGE,
  SET_DOCUMENT_FROM_REDUX,
  SET_DOCUMENT_FROM_DB,
  SET_LAST_VISIBLE_DOCUMENT,
  SET_DOCUMENTS,
  PAGINATE_DOCUMENTS,
  CREATE_DOCUMENT,
  MODIFY_DOCUMENT,
  REMOVE_DOCUMENT,
  STORE_DOCUMENT,
  LOADING_DOCUMENT,
  STOP_LOADING_DOCUMENT,
  SET_DOCUMENT_NOT_FOUND,
  RESET_DOCUMENT,
} from '../types'

const initialState = {
  documents: [],
  document: null,
  lastVisibleDocument: {
    Completed: {
      doc: null,
      isRear: false,
    },
    Expired: {
      doc: null,
      isRear: false,
    },
    Rejected: {
      doc: null,
      isRear: false,
    },
  },
  store: {},
  page: {},
  loading: false,
  notFound: false,
  refresh: 0,
}

const documentReducer = (state = initialState, action) => {
  let index
  switch (action.type) {
    case LOADING_DOCUMENT:
      return {
        ...state,
        loading: true,
      }
    case STOP_LOADING_DOCUMENT:
      return {
        ...state,
        loading: false,
      }

    case INCREMENT_REFRESH:
      state.refresh++
      return {
        ...state,
      }

    case SET_PAGE:
      return {
        ...state,
        page: {
          pageNumber: action.payload.pageNumber,
          originalPageHeight: action.payload.originalPageHeight,
          originalPageWidth: action.payload.originalPageWidth,
          pageHeight: action.payload.pageHeight,
          pageWidth: action.payload.pageWidth,
          offsetLeft: action.payload.offsetLeft,
          offsetTop: action.payload.offsetTop,
          multiplier: action.payload.multiplier,
        },
      }
    case SET_DOCUMENT_FROM_DB:
      return {
        ...state,
        document: action.payload,
        loading: false,
      }

    case SET_DOCUMENT_FROM_REDUX:
      index = state.documents.findIndex((doc) => doc.id === action.payload)
      if (index !== -1) {
        state.document = state.documents[index]
      } else {
        state.notFound = true
      }
      return {
        ...state,
        loading: false,
      }

    case SET_LAST_VISIBLE_DOCUMENT:
      return {
        ...state,
        lastVisibleDocument: {
          ...state.lastVisibleDocument,
          [action.payload.status]: {
            ...state.lastVisibleDocument[action.payload.status],
            ...action.payload.data,
          },
        },
      }

    case SET_DOCUMENTS:
      return {
        ...state,
        documents: action.payload,
        loading: false,
      }

    case CREATE_DOCUMENT:
      if (state.document && state.document.id === action.payload.id) {
        state.document = action.payload
      }
      return {
        ...state,
        documents: [...state.documents, action.payload],
      }

    case MODIFY_DOCUMENT:
      index = state.documents.findIndex((doc) => doc.id === action.payload.id)
      if (index !== -1) {
        state.documents[index] = action.payload
      }
      if (state.document && state.document.id === action.payload.id) {
        state.document = action.payload
      }
      return {
        ...state,
        loading: false,
      }

    case REMOVE_DOCUMENT:
      index = state.documents.findIndex((doc) => doc.id === action.payload)
      if (index !== -1) {
        state.documents.splice(index, 1)
      }
      return {
        ...state,
        loading: false,
      }

    case PAGINATE_DOCUMENTS:
      return {
        ...state,
        loading: false,
        documents: [...state.documents, ...action.payload],
      }

    case STORE_DOCUMENT:
      return {
        ...state,
        store: action.payload,
      }

    case SET_DOCUMENT_NOT_FOUND:
      return {
        ...state,
        notFound: true,
        loading: false,
        document: null,
      }

    case RESET_DOCUMENT:
      return initialState

    default:
      return state
  }
}

export default documentReducer
